import Joi from "joi";

export const assetCategoriesSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  // isDefault: Joi.boolean().label("Is Default"),
});
